export default __webpack_public_path__ + "static/IvarHeadline-Regular-2eff21c7cbb432fec76702a168614918.eot";